import { render, staticRenderFns } from "./StavL_Summary_List.vue?vue&type=template&id=6e6e8953"
import script from "./StavL_Summary_List.vue?vue&type=script&lang=js"
export * from "./StavL_Summary_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports